import React from 'react';
import { Link } from 'react-router-dom';

import styles from '../../../../stylesheets/public/components/List.module.postcss';

const CITIES_SEATTLE = [
  'Algona',
  'Auburn',
  'Beaux Arts Village',
  'Bellevue',
  'Black Diamond',
  'Bothell',
  'Burien',
  'Carnation',
  'Clyde Hill',
  'Covington',
  'Des Moines',
  'Duvall',
  'Enumclaw',
  'Federal Way',
  'Hunts Point',
  'Issaquah',
  'Kenmore',
  'Kent',
  'Kirkland',
  'Lake Forest Park',
  'Maple Valley',
  'Medina',
  'Mercer Island',
  'Milton',
  'Newcastle',
  'Normandy Park',
  'North Bend',
  'Pacific',
  'Redmond',
  'Renton',
  'Sammamish',
  'SeaTac',
  'Seattle',
  'Shoreline',
  'Skykomish',
  'Snoqualmie',
  'Tukwila',
  'Woodinville',
  'Yarrow Point'
];

const CITIES_AUSTIN = [
  'Austin',
  'Bastrop',
  'Bee Cave',
  'Buda',
  'Burnet',
  'Cedar Park',
  'Creedmoor',
  'Del Valle',
  'Dripping Springs',
  'Elgin',
  'Florence',
  'Georgetown',
  'Granger',
  'Hutto',
  'Jarrell',
  'Jonestown',
  'Kyle',
  'Lago Vista',
  'Lakeway',
  'Leander',
  'Liberty Hill',
  'Lockhart',
  'Luling',
  'Manor',
  'Marble Falls',
  'Mustang Ridge',
  'Pflugerville',
  'Point Venture',
  'Rollingwood',
  'Round Rock',
  'San Marcos',
  'Smithville',
  'Spicewood',
  'Sunset Valley',
  'Taylor',
  'Volente',
  'West Lake Hills',
  'Wimberley',
];

const CITIES_PORTLAND = [
  'Amity',
  'Banks',
  'Barlow',
  'Battle Ground',
  'Beaverton',
  'Camas',
  'Canby',
  'Carlton',
  'Clatskanie',
  'Columbia City',
  'Cornelius',
  'Dayton',
  'Dundee',
  'Durham',
  'Estacada',
  'Fairview',
  'Forest Grove',
  'Gaston',
  'Gladstone',
  'Gresham',
  'Happy Valley',
  'Hillsboro',
  'Johnson City',
  'King City',
  'La Center',
  'Lafayette',
  'Lake Oswego',
  'Maywood Park',
  'McMinnville',
  'Milwaukie',
  'Molalla',
  'Newberg',
  'North Bonneville',
  'North Plains',
  'Oregon City',
  'Portland',
  'Prescott',
  'Rainier',
  'Ridgefield',
  'Rivergrove',
  'Sandy',
  'Scappoose',
  'Sheridan',
  'Sherwood',
  'St. Helens',
  'Stevenson',
  'Tigard',
  'Troutdale',
  'Tualatin',
  'Vancouver',
  'Vernonia',
  'Washougal',
  'West Linn',
  'Willamina',
  'Wilsonville',
  'Wood Village',
  'Woodland',
  'Yacolt',
  'Yamhill'
];

function CityList({ cityName, vehicleType }) {
  let cityList = CITIES_SEATTLE;
  if (cityName === 'Austin') {
    cityList = CITIES_AUSTIN;
  } else if (cityName === 'Portland') {
    cityList = CITIES_PORTLAND;
  }

  return (
    <div>
      <h3>Browse by city</h3>
      <div className={styles.List_items}>
        { cityList.map((city) => (
          <div
            className={styles.List_item}
            key={city}
          >
            <Link to={`/search?open_today=true&location=${city.split(' ').join('-').toLowerCase()}`} >
              Food {vehicleType}s in {city}
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CityList;
